export const splitLabelLastWord = (label: string): { labelStart: string; labelLastWord: string } => {
  const lastSpaceIndex = label.lastIndexOf(" ");

  if (lastSpaceIndex === -1) {
    return { labelStart: "", labelLastWord: label };
  }

  return { labelStart: label.slice(0, lastSpaceIndex + 1), labelLastWord: label.slice(lastSpaceIndex + 1) };
};
